import { PrivateInterceptor } from "../../Base/interceptors/PrivateInterceptor";

// OBTIENE TODAS LAS EXTENCIONES
export const getExtensiones = async () => {
    const respuesta = PrivateInterceptor('Home/Extensiones', 'GET')
    return respuesta
};